import { render, staticRenderFns } from "./OfferActionBlock.vue?vue&type=template&id=b2af5b24&scoped=true&"
import script from "./OfferActionBlock.vue?vue&type=script&lang=ts&"
export * from "./OfferActionBlock.vue?vue&type=script&lang=ts&"
import style0 from "./OfferActionBlock.vue?vue&type=style&index=0&id=b2af5b24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2af5b24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
